import React, { useState, useEffect, useRef } from 'react';
import Placeholder from '@/components/Placeholder';
import { dispatch } from '@@/store';
import './index.less';
export default () => {
    const [count, setCount] = useState(5);
    const timer = useRef(undefined);
    useEffect(() => {
        timer.current = window.setInterval(() => {
            const nextCount = count - 1;
            if (nextCount === 0) {
                dispatch.router.replace('/home');
            }
            else {
                setCount(nextCount);
            }
        }, 1000);
        return () => {
            window.clearInterval(timer.current);
        };
    }, [count]);
    return (<div className="page-404">
      <Placeholder text="对不起，页面出错啦!">
        <p className="timeout">{count} 秒后返回首页</p>
      </Placeholder>
    </div>);
};
